import { Grid, Paper } from '@mui/material'
import {
  Control,
  FieldValues,
  Path,
  PathValue,
  useFieldArray,
  UseFormSetValue,
  UseFormWatch,
} from 'react-hook-form'
import { FieldArrayPath } from 'react-hook-form/dist/types/path'
import { FamiliarCompositionItem } from 'pages/SocioeducationMeasureEdit/FamilyData/components/FamiliarCompositionList/components/FamiliarCompositionItem'
import React, { useEffect, useState } from 'react'
import AddRoundedIcon from '@mui/icons-material/AddRounded'
import { ButtonSecondary } from 'components/ButtonSecondary'
import { ItemOption } from 'components/InputSelect'

interface FamiliarCompositionListProps<
  TFieldValues extends FieldValues,
  TFieldArrayName extends FieldArrayPath<TFieldValues>,
> {
  control: Control<TFieldValues>
  watch: UseFormWatch<TFieldValues>
  setValue: UseFormSetValue<TFieldValues>
  fieldArrayName: TFieldArrayName
  initialValuesFieldName: Path<TFieldValues>
  disabled?: boolean
  initialValues: PathValue<TFieldValues, Path<TFieldValues>>
  buttonLabel: string
  hasAddress?: boolean
  familiarReferenceOptions: ItemOption[]
  labels: {
    labelDeleteItem: string
  }
}

export const FamiliarCompositionList = <
  TFieldValues extends FieldValues,
  TFieldArrayName extends FieldArrayPath<TFieldValues>,
>({
  control,
  watch,
  initialValuesFieldName,
  fieldArrayName,
  initialValues,
  setValue,
  disabled,
  buttonLabel,
  hasAddress,
  familiarReferenceOptions,
  labels,
}: FamiliarCompositionListProps<TFieldValues, TFieldArrayName>) => {
  const [disableAddButton, setDisableAddButton] = useState<boolean>(true)

  const { fields, append, remove } = useFieldArray<TFieldValues>({
    control,
    name: fieldArrayName,
  })

  const values = watch(initialValuesFieldName)

  const lastItem = values && values[values.length - 1]
  const isFilled: boolean = lastItem && !lastItem.pessoaReferencia?.nome

  useEffect(() => {
    if (disabled) {
      setDisableAddButton(true)
    } else {
      setDisableAddButton(isFilled)
    }
  }, [disabled, isFilled])

  useEffect(() => {
    if (values && !values.length) {
      setValue(initialValuesFieldName, initialValues, { shouldDirty: false })
    }
  }, [values, setValue])

  return (
    <Grid container item spacing={2} xs={12}>
      {fields.map((field, index) => (
        <Grid key={field.id} item xs={12}>
          <Paper variant='outlined' sx={{ p: 3, width: '100%', backgroundColor: 'white' }}>
            <FamiliarCompositionItem
              control={control}
              watch={watch}
              setValue={setValue}
              name={initialValuesFieldName}
              index={index}
              disabled={disabled}
              hasAddress={hasAddress}
              familiarReferenceOptions={familiarReferenceOptions}
              showDeleteButton={values.length > 1}
              onDelete={remove}
              labels={labels}
            />
          </Paper>
        </Grid>
      ))}
      <Grid item xs={12}>
        <ButtonSecondary
          startIcon={<AddRoundedIcon />}
          label={buttonLabel}
          onClick={() => append(initialValues)}
          disabled={disableAddButton}
        />
      </Grid>
    </Grid>
  )
}
